import React from 'react';

const PostGraduation = () => {
    return (
        <div className="programme-details">
            <div className="programme-title">
                <h2>Post - Graduation</h2>
            </div>
            <div className="programme-descripttion">
                <h3>What is Post - Graduation ? </h3>
                <p>A postgraduate course is typically one year’s duration full time or it can take two years to complete part-time. A postgraduate diploma, postgraduate degree or Master's degree offers the student an advanced level of education in their chosen area of study.The course content is designed to build on the knowledge obtained at undergraduate degree level. Often the course content is more practical in nature to better prepare the student with the skills they will need in the workplace. Completing postgraduate studies helps students further their career prospects and deepen their understanding of their area of study.</p>
            
            <h3>Our Post - Graduate Programmes : </h3>
            <ul>
                <li>Aviation Management .</li>
                <li>Aircraft Design .</li>
                <li>Software architecture .</li>
            </ul>
            <h3>Duration : </h3>
                <ul>
                    <li>Full Course 2 Years .</li>
                    <li>4 Month (each semester) .</li>
                </ul>
            <h3>What is the Pre-requerments for this course ?</h3>
                <ul>
                    <li>Must Needed English proficiency Certificate (IELTS, TOFEL, DUOLINGO etc) .</li>
                    <li>Graduate or equivalente certificate .</li>
                    <li>Completed Graduation must be reletaed this subject .</li>
                </ul>
                </div>
        </div>
    );
};

export default PostGraduation;